import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function categoryFacets(categoryId:string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('categoryFacets')
    .setMethod('POST')
    .setProps([{categoryId: categoryId}])
    .send();
}
